import { getElements, getElement } from '../utils/functional'

export default class ModalFullScreen {
  constructor (el) {
    this.els = {
      triggers: getElements('[data-modal-trigger]'),
      modal: getElement('[data-modal]'),
      modalClose: getElement('[data-modal-close]'),
      body: getElement('body'),
      main: getElement('main')
    }
    this.setListeners()
  }

  setListeners () {
    this.els.triggers.forEach(trigger => {
      trigger.addEventListener('click', evt => {
        evt.preventDefault()
        this.els.modal.classList.add('md-Modal-open')
        this.els.body.classList.add('util-NoScroll', 'util-ModalActive')
        this.els.main.classList.add('mn-Content-onTop')
      })
    })
    this.els.modalClose.addEventListener('click', evt => {
      evt.preventDefault()
      this.els.modal.classList.remove('md-Modal-open')
      this.els.body.classList.remove('util-NoScroll', 'util-ModalActive')
      this.els.main.classList.remove('mn-Content-onTop')
    })
  }
}
